import { render } from "./EditRulePage.vue?vue&type=template&id=2e35c211&ts=true"
import script from "./EditRulePage.vue?vue&type=script&lang=ts"
export * from "./EditRulePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__